/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SsoInferGlobalStaffRoleSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('SSO_INFER_GLOBAL_STAFF_ROLE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class SsoInferGlobalStaffRoleSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SsoInferGlobalStaffRoleSettingParser.decode(input).map(res => new SsoInferGlobalStaffRoleSetting(res));
    }
    static unsafeDecode(input) {
        return SsoInferGlobalStaffRoleSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SsoInferGlobalStaffRoleSettingParser.encode(data);
    }
    static schema() {
        return SsoInferGlobalStaffRoleSettingParser.schema();
    }
}
